import config from '../../config/App_data';
import GetData from '../../RestAPI/getDataService';
import postData from '../../RestAPI/fetchData';

const getUserPerformanceBarGraph = async data => {
  return await GetData.callAPI(`${config.backend_api}/exams/cfa/dashboard/user-bar-graph`, data);
};
const getTotalUsersPerformanceBarGraph = async (data = {}) => {
  return await GetData.callAPI(
    `${config.backend_api}/exams/cfa/dashboard/all-user-bar-graph`,
    data,
  );
};
const sendFurtherHelpRequest = async (data = {}) => {
  return await postData.callAPI(`${config.backend_api}/contact_us/sendReportHelpRequest`, data);
};
const fetchQuestionProgressBar = async (data = {}) => {
  return await GetData.callAPI(
    `${config.backend_api}/exams/cfa/dashboard/question-progress-bar`,
    data,
  );
};
const fetchNotesProgressBar = async (data = {}) => {
  return await GetData.callAPI(
    `${config.backend_api}/exams/cfa/dashboard/notes-progress-bar`,
    data,
  );
};
//* QUESTION SAVE AND REPORT STARTED HERE
const fetchSavedQuestion = async data => {
  return await GetData.callAPI(`${config.backend_api}/exams/cfa/dashboard/saved-question`, data);
};
const fetchReportedQuestion = async data => {
  return await GetData.callAPI(`${config.backend_api}/exams/cfa/dashboard/reported-question`, data);
};
const deleteReportedQuestion = async data => {
  return await postData.callAPI(`${config.backend_api}/exams/cfa/dashboard/tab-items`, {
    id: data.id,
    type: 'report',
    itemType: 'Question',
  });
};
const updateReportedQuestion = async data => {
  return await postData.callAPI(`${config.backend_api}/exams/cfa/dashboard/edit-reports`, {
    id: data.id,
    comment: data.comment,
    itemType: 'Question',
  });
};

const deleteSavedQuestion = async data => {
  return await postData.callAPI(`${config.backend_api}/exams/cfa/dashboard/tab-items`, {
    id: data.id,
    type: 'save',
    itemType: 'Question',
  });
};
//* NOTES SAVE AND REPORT STARTED HERE
const fetchSavedNotes = async data => {
  return await GetData.callAPI(`${config.backend_api}/exams/cfa/dashboard/saved-notes`, data);
};
const fetchReportedNotes = async data => {
  return await GetData.callAPI(`${config.backend_api}/exams/cfa/dashboard/reported-notes`, data);
};
const deleteSavedNotes = async data => {
  return await postData.callAPI(`${config.backend_api}/exams/cfa/dashboard/tab-items`, {
    id: data.id,
    type: 'save',
    itemType: 'Notes',
  });
};
const deleteReportedNotes = async data => {
  return await postData.callAPI(`${config.backend_api}/exams/cfa/dashboard/tab-items`, {
    id: data.id,
    type: 'report',
    itemType: 'Notes',
  });
};
const updateReportedNotes = async data => {
  return await postData.callAPI(`${config.backend_api}/exams/cfa/dashboard/edit-reports`, {
    id: data.id,
    comment: data.comment,
    itemType: 'Notes',
  });
};

//* VIDEOS SAVE AND REPORT STARTED HERE
const fetchSavedVideos = async data => {
  return await GetData.callAPI(`${config.backend_api}/exams/cfa/dashboard/saved-videos`, data);
};
const fetchReportedVideos = async data => {
  return await GetData.callAPI(`${config.backend_api}/exams/cfa/dashboard/reported-videos`, data);
};
const deleteSavedVideo = async data => {
  return await postData.callAPI(`${config.backend_api}/exams/cfa/dashboard/tab-items`, {
    id: data.id,
    type: 'save',
    itemType: 'Video',
  });
};
const deleteReportedVideo = async data => {
  return await postData.callAPI(`${config.backend_api}/exams/cfa/dashboard/tab-items`, {
    id: data.id,
    type: 'report',
    itemType: 'Video',
  });
};
const updateReportedVideo = async data => {
  return await postData.callAPI(`${config.backend_api}/exams/cfa/dashboard/edit-reports`, {
    id: data.id,
    comment: data.comment,
    itemType: 'Video',
  });
};
const redirectToQuestion = async data => {
  return await postData.callAPI(
    `${config.backend_api}/exams/cfa/dashboard/redirect-question`,
    data,
  );
};
const redirectToCbtQuestion = async data => {
  return await GetData.callAPI(`${config.backend_api}/exams/cfa/dashboard/redirect-mocks`, data);
};
const redirectToNotes = async data => {
  return await postData.callAPI(`${config.backend_api}/exams/cfa/dashboard/redirect-notes`, data);
};
const redirectToVideos = async data => {
  return await postData.callAPI(`${config.backend_api}/exams/cfa/dashboard/redirect-videos`, data);
};

//* CBT SAVE AND REPORT STARTED HERE
const fetchCBTReportedQuestion = async data => {
  return await GetData.callAPI(`${config.backend_api}/exams/cfa/dashboard/reported-mocks`, data);
};
// redirectToCBTQuestion
const deleteCBTReportedQuestion = async data => {
  return await postData.callAPI(`${config.backend_api}/exams/cfa/dashboard/tab-items`, {
    id: data.id,
    type: 'reportCBT',
    itemType: 'Question',
  });
};
const updateReportedCBTQuestion = async data => {
  return await postData.callAPI(`${config.backend_api}/exams/cfa/dashboard/edit-reports`, {
    id: data.id,
    comment: data.comment,
    itemType: 'CBTQuestion',
  });
};

const deleteFlashCard = async data => {
  return await postData.callAPI(`${config.backend_api}/question_bank_2024/deleteFlashCard`, data);
};
module.exports = {
  getUserPerformanceBarGraph,
  getTotalUsersPerformanceBarGraph,
  fetchQuestionProgressBar,
  fetchNotesProgressBar,
  fetchSavedQuestion,
  deleteSavedQuestion,
  deleteFlashCard,
  fetchReportedQuestion,
  deleteReportedQuestion,
  updateReportedQuestion,
  fetchSavedNotes,
  fetchReportedNotes,
  deleteSavedNotes,
  deleteReportedNotes,
  updateReportedNotes,
  fetchSavedVideos,
  fetchReportedVideos,
  deleteSavedVideo,
  deleteReportedVideo,
  updateReportedVideo,
  fetchCBTReportedQuestion,
  deleteCBTReportedQuestion,
  updateReportedCBTQuestion,
  sendFurtherHelpRequest,
  redirectToQuestion,
  redirectToNotes,
  redirectToVideos,
  redirectToCbtQuestion,
};



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Dashboard/ApiService.js